// quick-shop.js
document.addEventListener('DOMContentLoaded', function () {
  const globalModal = document.querySelector('#quick-shop');
  const buttons = document.querySelectorAll('.quick-shop-button');

  let modalToClose;
  let closeButton;
  let productData;

  let previousURL = window.location.href;

  if (!globalModal) {
    console.error('globalModal element #quick-shop not found.');
    return;
  }

  const getProductData = async (productHandle) => {
    const response = await fetch(`/products/${productHandle}.js`);
    const data = await response.json();
    return data;
  };

  const updateUrl = (productData) => {
    const url = new URL(productData.url, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set('variant', productData.variants[0].id);

    const newUrl =
      window.location.origin +
      Shopify.routes.root +
      'products/' +
      productData.handle +
      '?' +
      searchParams.toString();

    window.history.pushState({}, '', newUrl);
  };

  const handleClose = () => {
    const modalInner = modalToClose.querySelector('.quick-shop-modal-inner');
    modalInner.classList.add('translate-y-full');

    setTimeout(() => {
      modalToClose.classList.add('opacity-0');
    }, 50);

    setTimeout(() => {
      modalToClose.classList.add('hidden');
      if (globalModal.contains(modalToClose)) {
        globalModal.removeChild(modalToClose);
      }
      document.body.style.overflow = 'auto';
    }, 200);

    window.history.pushState({}, '', previousURL);
  };

  const handleOpen = (productHandle, productId) => {
    const modal = document.querySelector(`.quick-shop-modal-${productId}`);
    const clone = modal.cloneNode(true);
    const modalInner = clone.querySelector('.quick-shop-modal-inner');

    globalModal.appendChild(clone);

    modalToClose = globalModal.querySelector(`.quick-shop-modal-${productId}`);
    closeButton = modalToClose.querySelector(`.quick-shop-close-${productId}`);

    // Attach event listeners here, after elements are defined
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      handleClose();
    });

    modalToClose.addEventListener('click', function (event) {
      if (event.target === modalToClose) {
        handleClose();
      }
    });

    // Close modal when adding a product to the cart
    modalToClose
      .querySelector('button[type="submit"]')
      .addEventListener('click', function (event) {
        event.preventDefault();

        const variantId = modalToClose.querySelector('input#variant-id').value;
        const quantityInput = modalToClose.querySelector(
          'input[name="quantity"]',
        );
        const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: quantity,
              },
            ],
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            handleClose();
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
          });
      });

    // Attach change event listeners to variant options
    modalToClose.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', function () {
        variantSelect(productData, modalToClose);
      });
    });

    setTimeout(() => {
      clone.classList.remove('hidden', 'opacity-0');
    }, 1);

    setTimeout(() => {
      modalInner.classList.remove('translate-y-full');
    }, 50);

    // Force reflow to ensure the transition occurs
    void modal.offsetWidth;

    document.body.style.overflow = 'hidden';

    getProductData(productHandle).then((data) => {
      if (data) {
        productData = data;
        updateUrl(productData);
      }
    });
  };

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.quick-shop-button');
    if (button) {
      event.preventDefault();
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      handleOpen(productHandle, productId);
    }
  });

  // Optional: Close modal on Esc key press
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (modalToClose) {
        handleClose();
      }
    }
  });

  // Expose variantSelect to the global scope
  window.variantSelect = variantSelect;
});

function updateVariantUrl(productData, variant) {
  const url = new URL(productData.url, window.location.origin);
  const searchParams = new URLSearchParams(url.search);
  searchParams.set('variant', variant.id);

  const newUrl =
    window.location.origin +
    Shopify.routes.root +
    'products/' +
    productData.handle +
    '?' +
    searchParams.toString();

  window.history.pushState({ variant: variant.id }, '', newUrl);
}

function findVariantId(productData, selectedOptions) {
  return productData.variants.find((variant) => {
    return selectedOptions.every((optionValue, index) => {
      const variantOption = variant[`option${index + 1}`];
      return (
        variantOption &&
        variantOption.toLowerCase() === optionValue.toLowerCase()
      );
    });
  });
}

function variantSelect(productData, modal) {
  const form = modal.querySelector(`#quick-shop-form-${productData.id}`);
  const options = form.querySelectorAll('input[type="radio"]');

  const variantIdField = form.querySelector('input#variant-id');

  const ORIGINALID = document.querySelector(
    `.card .quick-shop-modal-${productData.id} input#variant-id`,
  );

  if (!productData) {
    console.error('Product data is not available.');
    return;
  }

  const selectedOptions = Array.from(options)
    .filter((option) => option.checked)
    .map((option) => option.value);

  const variant = findVariantId(productData, selectedOptions);

  if (variant) {
    variantIdField.value = variant.id;
    ORIGINALID.value = variant.id;
    updateVariantUrl(productData, variant);
  } else {
    console.error('Variant not found for selected options.');
  }
}
